import { setLoading } from "../redux/app_global/reducer";
import { setLoading as setLoadingOrganization, setOrganization_id, setOrganization_list, setOrganization_my, setOrganization_rating, setOrganization_specialists_specialization, setOrganization_specialists, setOrganization_categories } from "../redux/organization/reducer";
import Request, { RequestFile } from "./handler.js";

export const getOrganizationSeo = async (data) => {
    var result = {};
    
    data.method = 'organization_seo';

    await Request(data, 'post')
    .then(async json => {
        result = json;
    });

    return result;
}

export const getOrganizationSpecialistsSpecializationList = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_specialists_specialization_list';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setOrganization_specialists_specialization(json.result));
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const getOrganizationSpecialistsList = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_specialists_list';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setOrganization_specialists(json.result));
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const getOrganizationCategoriesList = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_categories_list';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setOrganization_categories(json.result));
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const getOrganizationList = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_list';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setOrganization_list(json.result));
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const getOrganizationRating = async (data,dispatch) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_rating';
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setOrganization_rating(json.result));
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const getOrganizationMy = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_my';

    if (profile.token) {
        data.token = profile.token;
    }

    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setOrganization_my(json.result));
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const getOrganizationId = async (data,dispatch,profile) => {
    var result = {};
    
    data.method = 'organization_id';

    if (profile.token) {
        data.token = profile.token;
    }

    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            if (Object.keys(json?.result).length > 0) {
                json.result['error_code'] = 200;
                await dispatch(setOrganization_id(json?.result));
            } else {
                await dispatch(setOrganization_id({error_code:404}));
            }
        }

        result = json;
    });

    return result;
}

export const addOrganization = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_add';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const addOrganizationPhone = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_add_phone';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const addOrganizationWorktime = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_add_worktime';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const addOrganizationWorktime_admin = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_add_worktime_admin';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const addOrganizationServices = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_add_services';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const addOrganizationSpecialists = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_add_specialists';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const addReview = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_add_review_new';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const addOrganizationReview = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.append('method','organization_add_review');

    if (profile.token) {
        data.append('token',profile.token);
    }
    
    await RequestFile(data)
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const updOrganizationData = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_upd_data';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const updOrganizationSoc = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_upd_soc';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const updOrganizationContent = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_upd_content';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const updOrganizationLocation = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_upd_location';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const updOrganizationSeo = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_upd_seo';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const updOrganizationPhone = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_upd_phone';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const updOrganizationPrice = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_upd_price';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const updOrganizationWorktime = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_upd_worktime';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const updOrganizationWorktime_admin = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_upd_worktime_admin';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const updOrganizationServices = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_upd_services';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const updOrganizationSpecialists = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_upd_specialists';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const updOrganizationModeration = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_upd_moderation';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const delOrganizationPhone = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_del_phone';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const delOrganizationWorktime = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_del_worktime';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const delOrganizationWorktime_admin = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_del_worktime_admin';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const delOrganizationServices = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_del_services';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const delOrganizationSpecialists = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_del_specialists';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const delOrganizationHeaderPc = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_del_header_pc';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const delOrganizationHeaderMob = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_del_header_mob';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const delOrganizationPhotos = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_del_photos';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const delOrganizationCertificates = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_del_certificates';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const delOrganizationPrice = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_del_price';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const delOrganizationLogo = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_del_logo';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const addOrganizationCategories = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_categories_add';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}

export const updOrganizationCategories = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingOrganization(true));
    data.method = 'organization_categories_upd';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingOrganization(false));

    return result;
}